module.exports = __webpack_public_path__ + "img/exclude.bac5eeb2.svg";